import { render, staticRenderFns } from "./permissionsCard.vue?vue&type=template&id=47c8f412&scoped=true"
import script from "./permissionsCard.vue?vue&type=script&lang=js"
export * from "./permissionsCard.vue?vue&type=script&lang=js"
import style0 from "./permissionsCard.vue?vue&type=style&index=0&id=47c8f412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8f412",
  null
  
)

export default component.exports